// extracted by mini-css-extract-plugin
export default {"input":"EmailSection_input__pYUR2"};